import { usePublicFeatureFlags } from '@/shared/api/featureFlagsQueries'

/**
 * Whether the MatchEvent module (multi-club sports ticketing, cf. `MatchClub` catalogue - never a
 * single hardcoded club, D4b) is enabled for this tenant. A disabled/missing module row means
 * /match-event 404s server-side (`feature:match-event` middleware); nav must not offer a link to it,
 * and the /match-event pages themselves must not fire queries against it (direct/bookmarked access).
 */
export function useMatchEventFeatureFlag(): { enabled: boolean; isLoading: boolean } {
  const flagsQuery = usePublicFeatureFlags()
  return {
    enabled: flagsQuery.data?.find((row) => row.module_name === 'match-event')?.enabled === true,
    isLoading: flagsQuery.isPending,
  }
}

export function useMatchEventEnabled(): boolean {
  return useMatchEventFeatureFlag().enabled
}
